import React, { useEffect, useState } from "react";
import "./FloatingIcons.css";
import WhatsApp from "../../assets/image/whatsapp.png";
import FacebookIcon from "../../assets/image/facebook.png";
import InstagramIcon from "../../assets/image/instagram.jpg";
import YoutubeIcon from "../../assets/image/youtube.png";
import axios from "axios";

const API_URL = "https://dashboard.jyotirvani.com/api/contactpage";

const FloatingIcons = () => {
  const [socialLinks, setSocialLinks] = useState({
    fb: "#",
    insta: "#",
    phone: "",
  });

  useEffect(() => {
    axios
      .get(API_URL)
      .then((res) => {
        const data = res.data?.data;
        setSocialLinks({
          fb: data?.fb || "#",
          insta: data?.insta || "#",
          phone: data?.phno || "",
        });
      })
      .catch((err) => {
        console.error("Failed to load social links", err);
      });
  }, []);

  return (
    <div>
      <div className="floating-icons">
        <a href={socialLinks.fb} target="_blank" rel="noopener noreferrer">
          <img src={FacebookIcon} alt="Facebook" />
        </a>
        <a href={socialLinks.insta} target="_blank" rel="noopener noreferrer">
          <img src={InstagramIcon} alt="Instagram" />
        </a>
        <a
          href="https://www.youtube.com/@jyotirvani"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={YoutubeIcon} alt="YouTube" />
        </a>
      </div>

      <div className="floating-icons-whatapp">
        <a
          href={`https://wa.me/91${socialLinks.phone}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={WhatsApp} alt="WhatsApp" />
        </a>
      </div>
    </div>
  );
};

export default FloatingIcons;
